export default __webpack_public_path__ + "static/media/ltr-gp-img.5d555fa8.webp";